export const SPONSOR_SLOT_TEMPLATES = [
    {
        id: 'main-sponsor',
        titleKey: 'sponsors.offer.slots.catalog.main-sponsor.title',
        descriptionKey: 'sponsors.offer.slots.catalog.main-sponsor.description',
        maxSponsorsTotalForSlot: 1
    },
    {
        id: 'featured-sponsor',
        titleKey: 'sponsors.offer.slots.catalog.featured-sponsor.title',
        descriptionKey: 'sponsors.offer.slots.catalog.featured-sponsor.description',
        maxSponsorsTotalForSlot: 2
    },
    {
        id: 'class-sponsor',
        titleKey: 'sponsors.offer.slots.catalog.class-sponsor.title',
        descriptionKey: 'sponsors.offer.slots.catalog.class-sponsor.description',
        maxSponsorsPerClass: 2
    },
    {
        id: 'competition-sponsor',
        titleKey: 'sponsors.offer.slots.catalog.competition-sponsor.title',
        descriptionKey: 'sponsors.offer.slots.catalog.competition-sponsor.description'
    },
    {
        id: 'bonus-sponsor',
        titleKey: 'sponsors.offer.slots.catalog.bonus-sponsor.title',
        descriptionKey: 'sponsors.offer.slots.catalog.bonus-sponsor.description',
    }
];
